"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interestSchema = exports.interestItemSchema = void 0;
const zod_1 = require("zod");
const helpers_1 = require("../helpers");
const travelInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-plane-departure"),
    interest: zod_1.z.literal("travel"),
    displayName: zod_1.z.literal("Viagens e turismo"),
});
const popCultureInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-tv-retro"),
    interest: zod_1.z.literal("pop-culture"),
    displayName: zod_1.z.literal("Cultura pop (filmes, música, séries)"),
});
const sportsInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-football"),
    interest: zod_1.z.literal("sports"),
    displayName: zod_1.z.literal("Esportes"),
});
const technologyInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-processor"),
    interest: zod_1.z.literal("technology"),
    displayName: zod_1.z.literal("Tecnologia e inovação"),
});
const gastronomyInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-utensils"),
    interest: zod_1.z.literal("gastronomy"),
    displayName: zod_1.z.literal("Gastronomia e culinária internacional"),
});
const fashionInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-plane-departure"),
    interest: zod_1.z.literal("fashion"),
    displayName: zod_1.z.literal("Moda e tendências"),
});
const wellbeingInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-smile"),
    interest: zod_1.z.literal("wellbeing"),
    displayName: zod_1.z.literal("Saúde e bem-estar"),
});
const influencersInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-star"),
    interest: zod_1.z.literal("influencers"),
    displayName: zod_1.z.literal("Mídias sociais e influenciadores digitais"),
});
const musicInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-music"),
    interest: zod_1.z.literal("music"),
    displayName: zod_1.z.literal("Músicas e instrumentos musicais"),
});
const historyInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-hourglass"),
    interest: zod_1.z.literal("history"),
    displayName: zod_1.z.literal("História e civilizações antigas"),
});
const entrepeneurshipInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-bag"),
    interest: zod_1.z.literal("entrepeneurship"),
    displayName: zod_1.z.literal("Empreendedorismo e negócios"),
});
const sustainabilityInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-trees"),
    interest: zod_1.z.literal("sustentability"),
    displayName: zod_1.z.literal("Sustentabilidade e meio ambiente"),
});
const artsInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-image"),
    interest: zod_1.z.literal("arts"),
    displayName: zod_1.z.literal("Arte e pintura"),
});
const photographyInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-camera"),
    interest: zod_1.z.literal("photography"),
    displayName: zod_1.z.literal("Fotografia e edição de imagens"),
});
const literatureInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-book-open"),
    interest: zod_1.z.literal("literature"),
    displayName: zod_1.z.literal("Literatura e escritores famosos"),
});
const gamesInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-desktop-alt"),
    interest: zod_1.z.literal("games"),
    displayName: zod_1.z.literal("Jogos e videogames"),
});
const scienceInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-atom"),
    interest: zod_1.z.literal("science"),
    displayName: zod_1.z.literal("Ciência e descobertas recentes"),
});
const outdoorActivitiesInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-mountains-sun"),
    interest: zod_1.z.literal("outdoor-actitivies"),
    displayName: zod_1.z.literal("Atividades ao ar livre"),
});
const designInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-paint-tool"),
    interest: zod_1.z.literal("design"),
    displayName: zod_1.z.literal("Design de interiores e decoração"),
});
const philosophyInterest = zod_1.z.object({
    icon: zod_1.z.literal("uil-comments-alt"),
    interest: zod_1.z.literal("philoshophy"),
    displayName: zod_1.z.literal("Filosofia e pensadores renomados"),
});
const allInterests = (0, helpers_1.assertNonEmptyArray)([
    travelInterest,
    popCultureInterest,
    sportsInterest,
    technologyInterest,
    gastronomyInterest,
    fashionInterest,
    wellbeingInterest,
    influencersInterest,
    musicInterest,
    historyInterest,
    entrepeneurshipInterest,
    sustainabilityInterest,
    artsInterest,
    photographyInterest,
    literatureInterest,
    gamesInterest,
    scienceInterest,
    outdoorActivitiesInterest,
    designInterest,
    philosophyInterest,
]);
exports.interestItemSchema = zod_1.z.union(allInterests);
exports.interestSchema = zod_1.z.union((0, helpers_1.assertNonEmptyArray)(allInterests.map((interest) => interest.shape.interest)));
//# sourceMappingURL=interests.js.map